const emailPatternRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

export function isEmail(email: string): boolean {
    return emailPatternRegex.test(email.toLowerCase())
}

const LETTERS_NUMBERS_DASH_OR_UNDERSCORE = /^[a-z0-9-_]+$/

export function alphaNumericDashOrUnderscore(str: string): boolean {
  return LETTERS_NUMBERS_DASH_OR_UNDERSCORE.test(str)
} 